import React, { createContext, Component } from 'react';
import Lang from 'lang.js'; 
import messages from '../lang/lang.dist.json';
const LangContext = createContext();

class LangProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: new Lang({ messages: messages }),
    };
  }

  render() {
    return (
      <LangContext.Provider value={this.state}>
        {this.props.children}
      </LangContext.Provider>
    );
  }
}

export { LangProvider, LangContext };